
export default {
  state: {
    openModalSignIn: false,
    blockOverflow: 'none'
  },
  mutations: {
    openModalSignIn (state, payload) {
      state.openModalSignIn = 'none'
    }
  },
  actions: {
    blockOverflow ({commit}, payload) {
      commit('blockOverflow', payload)
    }
  },
  getters: {
    getValue (state) {
      return state.openModalSignIn
    },
    getOverflow (state) {
      return state.blockOverflow
    }
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/modal.store.js